import emojiData from 'emojibase-data/en/data.json';
import groupsMeta from 'emojibase-data/meta/groups.json';

const SECTION_LABELS = {
  0: 'Smileys & Emotion',
  1: 'People & Body',
  3: 'Animals & Nature',
  4: 'Food & Drink',
  5: 'Travel & Places',
  6: 'Activities',
  7: 'Objects',
  8: 'Symbols',
  9: 'Flags',
};

const SECTION_ORDER = [0, 1, 3, 4, 5, 6, 7, 8, 9];

const buildSections = () => SECTION_ORDER.map((groupId) => {
  const emojis = emojiData
    .filter(({ group, type }) => type === 1 && group === groupId)
    .map(({ emoji }) => emoji);

  return {
    id: String(groupId),
    title: SECTION_LABELS[groupId] || groupsMeta.groups[groupId],
    emojis: Array.from(new Set(emojis)),
  };
});

const popularEmojis = buildSections();

const buildSearchIndex = () => {
  const index = {};

  emojiData.forEach((entry) => {
    const {
      emoji,
      label,
      tags = [],
      order = Number.MAX_SAFE_INTEGER,
      group,
      skins = [],
    } = entry;

    if (!emoji || typeof emoji !== 'string') {
      return;
    }

    if (group === 2) {
      return;
    }

    index[emoji] = {
      label: label || '',
      tags,
      order,
      group,
      skins: skins.reduce((map, skin) => {
        if (skin && Number.isFinite(skin.tone) && typeof skin.emoji === 'string') {
          map[skin.tone] = skin.emoji;
        }
        return map;
      }, {}),
    };
  });

  return index;
};

const popularEmojiSearchIndex = buildSearchIndex();

export const popularEmojiSections = popularEmojis;
export const popularEmojiList = popularEmojis.reduce(
  (allEmojis, section) => allEmojis.concat(section.emojis),
  []
);
export const popularEmojiSearch = popularEmojiSearchIndex;

export default popularEmojis;
